import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Icon, ScreenReaderOnly } from '@statsbomb/kitbag-components';

export const FOOTBALL_IDENTIFIER = 'FOOTBALL';
export const NFL_IDENTIFIER = 'NFL';

const sports = [
  {
    apiValue: FOOTBALL_IDENTIFIER,
    icon: 'BallSoccer',
    potentialInputStrings: [FOOTBALL_IDENTIFIER, 'SOCCER'],
    title: <FormattedMessage defaultMessage="Football" id="449a5" />,
  },
  {
    apiValue: NFL_IDENTIFIER,
    icon: 'BallFootballCollege',
    potentialInputStrings: [NFL_IDENTIFIER, 'AMF'],
    title: <FormattedMessage defaultMessage="AMF" id="5d68f" />,
  },
];
const UNKNOWN = {
  icon: 'Support',
  title: <FormattedMessage defaultMessage="Not Provided" id="99817" />,
};

export const findSport = (inputValue) =>
  sports.find((sport) =>
    sport.potentialInputStrings.includes(inputValue?.toUpperCase()),
  );

export const sanitiseSport = (inputValue) => findSport(inputValue)?.apiValue;

export function SportIcon({ sport }) {
  return (
    <>
      <ScreenReaderOnly>{findSport(sport)?.title}</ScreenReaderOnly>
      <Icon size="small" variant={findSport(sport)?.icon || UNKNOWN.icon} />
    </>
  );
}
SportIcon.propTypes = {
  sport: PropTypes.string.isRequired,
};

export function Sport({ hideText, hideIcon, sport }) {
  return (
    <>
      {!hideIcon && <SportIcon sport={sport} />}
      {!hideText && (findSport(sport)?.title || UNKNOWN.title)}
    </>
  );
}

Sport.propTypes = {
  hideIcon: PropTypes.bool,
  hideText: PropTypes.bool,
  sport: PropTypes.string.isRequired,
};
Sport.defaultProps = {
  hideIcon: false,
  hideText: false,
};

export default { Sport };
